/* eslint-disable no-alert */
import React, { useRef, useEffect, useState } from 'react';

type Props = {
  as: ReactElement,
  children: ReactChildren,
};

export const HiddenMenu = ({as, children}: Props) => {
  const Component = as;
  const clickCount = useRef(0);
  const logoWrapperRef = useRef(null);
  const [isHiddenMenuDisabled, setIsHiddenMenuDisabled] = useState(false);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  const handleClickOutside = e => {
    if (logoWrapperRef.current && !logoWrapperRef.current.contains(e.target)) {
      setIsHiddenMenuDisabled(true);
    }
  };

  const showHiddenMenu = () => {
    Promise.all([fetch('/config.json'), fetch('/apps.json')])
    .then(([configResponse, appsResponse]) => {
      const config = configResponse.json();
      const apps = appsResponse.json();
      return Promise.all([config, apps]);
    })
    .then(([config, apps]) => {
      const apiRootStorage = localStorage.getItem('API_ROOT');
      const apiUrl = apiRootStorage || config.API_ROOT;
      // TODO: updated code to use each app commit id,
      // in the future we will have different commit ids for each app,
      const { commitID } = Object.values(apps)[0];
      let msg = `API: ${apiUrl}\n`;
      msg += 'Apps:\n';
      Object.keys(apps).forEach(app => {
        msg += `  ${app}: ${apps[app].version}\n`;
      });
      msg += `\nonline-store\n${commitID}\n`;
      msg += '\nWould you like to change API?\n';
      // eslint-disable-next-line no-restricted-globals
      if (confirm(msg) === true) {
        const API_URL = prompt('Type new API URL', 'https://vmos2.vmos-demo.com');
        if (API_URL !== null) {
          localStorage.setItem('API_ROOT', API_URL);
          alert(`API Changed to ${API_URL}\nRestart the application to see the changes.`);
        }
      }
    }).catch(error => console.log(error));
  };

  const onPress = () => {
    if (isHiddenMenuDisabled) return;

    clickCount.current = ++clickCount.current;
    if (clickCount.current === 5) {
      clickCount.current = 0;
      showHiddenMenu();
    }
  };
  return (
    <Component ref={logoWrapperRef} onClick={onPress}>
      {children}
    </Component>
  );
};

